

<app-shared [type]="'bon-transfert'" [status]="'Crée'"></app-shared>
